import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiQaroniEnv } from '@qaroni-core/conf/apis/api-qaroni.config';
import { FileApiObject } from '@qaroni-shared/types/file.response';

@Injectable({
  providedIn: 'root',
})
export class FilesUploadHttpService {
  private http = inject(HttpClient);

  public upload$(file: FormData) {
    const url = `${ApiQaroniEnv.URLBase}/admin/files/temps`;

    return this.http.post<FileApiObject>(url, file);
  }
}
